/* src/pages/quickscans/page-quickscans.component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=page-quickscans.component-OE4OU6BZ.css.map */
